module.exports = __webpack_public_path__ + "media/images/themes/light/arena-da3f037c0370b38c52585e80ab69fc82.png";